export const convertToMB = (size) => {
  if (!size) return ''
  const newSize = (size / (1024 * 1024)).toFixed(2)
  if (newSize === '0.00') return null
  return `${newSize} MB`
}
